import BpkCard from '@skyscanner-internal/backpack-web/bpk-component-card';
import BpkImage, {
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner-internal/backpack-web/bpk-component-image';
import BpkLoadingButton from '@skyscanner-internal/backpack-web/bpk-component-loading-button';
import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useMBDContext } from '../common/MBD/useMBDContext';

import SearchHotelsLogo from './search-hotels.svg';

import type { HotelSearchResultsWrapperClientStrings } from '@skyscanner-internal/landing-pages-shared-types/types-shared/HotelSearchResultsWrapperProps';

import STYLES from './SeoBannerSearchHotels.module.scss';

type Props = {
  dayViewUrl: string;
  fromSeoPage?: string;
  clientStrings: HotelSearchResultsWrapperClientStrings;
};

const documentIfExists = typeof window !== 'undefined' ? document : null;
const LazyLoadedImage = withLoadingBehavior(
  withLazyLoading(BpkImage, documentIfExists),
);

const SeoBannerSearchHotels = ({
  clientStrings,
  dayViewUrl,
  fromSeoPage = undefined,
}: Props) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = `${rawComponentName}_seo_banner`;
  const ctaComponentName = `${mbdComponentName}_cta`;
  const element = 'seo-banner-search-hotels';
  const bannerSubtitle =
    fromSeoPage === 'City'
      ? clientStrings.seoBannerSubtitleCity
      : clientStrings.seoBannerSearchHotelsCopy;

  return (
    <div
      className={STYLES.SeoBannerSearchHotels}
      data-tracking-element-id={mbdComponentName}
      data-tracking-common-params={buildMBDParam(mbdComponentName)}
    >
      <BpkCard className={STYLES.card} padded={false} atomic={false}>
        <div className={STYLES.SeoBannerSearchHotels__image}>
          <div className={STYLES.SeoBannerSearchHotels__logo}>
            <LazyLoadedImage
              alt={element}
              src={SearchHotelsLogo}
              aspectRatio={203 / 152}
              role="presentation"
            />
          </div>
        </div>

        <div className={STYLES.SeoBannerSearchHotels__middle}>
          <BpkText
            tagName="p"
            textStyle={TEXT_STYLES.label1}
            color={TEXT_COLORS.textPrimary}
            className={STYLES.SeoBannerSearchHotels__title}
          >
            {clientStrings.seoBannerSearchHotelsTitle}
          </BpkText>
          <div>
            <BpkText tagName="p" textStyle={TEXT_STYLES.bodyDefault}>
              {bannerSubtitle}
            </BpkText>
          </div>
        </div>
        <div className={STYLES.SeoBannerSearchHotels__btn}>
          <BpkLoadingButton
            target="_blank"
            rel="nofollow"
            href={dayViewUrl}
            data-tracking-element-id={ctaComponentName}
            data-tracking-common-params={buildMBDParam(ctaComponentName)}
          >
            {clientStrings.seoBannerSearchCTAText}
          </BpkLoadingButton>
        </div>
      </BpkCard>
    </div>
  );
};

export default SeoBannerSearchHotels;
